import React from 'react';

// Avatar options for under-13 users (10 avatars - mix of male, female, and neutral)
export const AVATAR_OPTIONS = [
  { id: 'avatar-1', name: 'Happy Artist', gender: 'neutral', emoji: '👦' },
  { id: 'avatar-2', name: 'Creative Kid', gender: 'neutral', emoji: '👧' },
  { id: 'avatar-3', name: 'Art Explorer', gender: 'male', emoji: '🧑‍🎨' },
  { id: 'avatar-4', name: 'Young Creator', gender: 'female', emoji: '👩‍🎨' },
  { id: 'avatar-5', name: 'Budding Artist', gender: 'male', emoji: '👨‍🎨' },
  { id: 'avatar-6', name: 'Art Lover', gender: 'female', emoji: '👩' },
  { id: 'avatar-7', name: 'Creative Mind', gender: 'neutral', emoji: '🧒' },
  { id: 'avatar-8', name: 'Art Student', gender: 'neutral', emoji: '👶' },
  { id: 'avatar-9', name: 'Young Painter', gender: 'male', emoji: '👨' },
  { id: 'avatar-10', name: 'Art Enthusiast', gender: 'female', emoji: '👩' },
];

export default function AvatarSelector({ selectedAvatar, onSelectAvatar }) {
  return (
    <div className="w-full">
      <h3 className="text-lg font-semibold text-slate-800 mb-4 text-center">
        Choose Your Avatar 🎨
      </h3>
      <div className="grid grid-cols-5 gap-4">
        {AVATAR_OPTIONS.map((avatar) => (
          <button
            key={avatar.id}
            type="button"
            onClick={() => onSelectAvatar(avatar.id)}
            className={`
              w-16 h-16 rounded-full text-4xl flex items-center justify-center
              border-4 transition-all duration-200
              ${selectedAvatar === avatar.id
                ? 'border-amber-500 bg-amber-100 scale-110 shadow-lg'
                : 'border-amber-200 bg-white hover:border-amber-300 hover:scale-105'
              }
            `}
            title={avatar.name}
          >
            {avatar.emoji}
          </button>
        ))}
      </div>
      {selectedAvatar && (
        <p className="text-center text-sm text-slate-600 mt-3">
          Selected: {AVATAR_OPTIONS.find(a => a.id === selectedAvatar)?.name}
        </p>
      )}
    </div>
  );
}

// Helper function to get avatar emoji by ID
export function getAvatarEmoji(avatarId) {
  const avatar = AVATAR_OPTIONS.find(a => a.id === avatarId);
  return avatar ? avatar.emoji : '👤'; // Default avatar
}
